import React from 'react';
import './styles.css';
import { Bar } from 'react-chartjs-2';
import i18n from '../../../translate/i18n';

interface TypeProps {
  title: string,
  label: string[],
  completa: number[],
  remota: number[],
  pericia: number[],
}

export default function WidgetChartGroupedBar({ title, label, completa, remota, pericia }: TypeProps) {


  const data = {
    labels: [...label],
    datasets: [{
      data: [...completa],
      label: i18n.t<string>('full'),
      backgroundColor: "#3DD598",
      borderWidth: 0
    },
    {
      data: [...remota],
      label: i18n.t<string>('remote'),
      backgroundColor: "#0062FF",
      borderWidth: 0
    },
    {
      data: [...pericia],
      label: i18n.t<string>('expertise'),
      backgroundColor: "#FFC542",
      borderWidth: 0
    }]
  };

  const options: any = {
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <div id='container-widget-chart-bar'>
      <h1>{title}</h1>
      <div id='widget-chart'>
        <Bar data={data} options={options} />
      </div>
    </div>
  )
}
